<template>
    <div>
        <b-row>
            <b-col>
                <el-input size="small" placeholder="Buscar" v-model="params.filter" />
            </b-col>

            <b-col>
                <b-button variant="primary" @click="fetchPositions(true)" :disabled="!params.company_id" size="sm"
                    class="mx-1">
                    <i class="fa fa-search" />
                    <span class="d-none d-md-inline-block ml-1" v-text="' Buscar'" />
                </b-button>

                <b-button :disabled="!params.company_id" size="sm" @click="resetParamsFilter" class="mx-1">
                    <i class="fa fa-eraser" />
                    <span class="d-none d-md-inline-block ml-1" v-text="' Limpiar'" />
                </b-button>

                <b-dropdown v-if="validarPermisoComponente('empresa-editar-cargos')" id="options" size="sm"
                    variant="primary" text="Opciones" class="float-right" :disabled="!params.company_id">
                    <b-dropdown-item @click="openModalForCreation()">
                        <i class="fa fa-plus" /> Crear
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloadTemplate">
                        <i class="fa fa-download" /> Descargar plantilla
                    </b-dropdown-item>
                    <b-dropdown-item @click="setShowToModalUpload(true)">
                        <i class="fa fa-upload" /> Carga masiva
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>

        <b-table hover striped responsive :fields="columns" show-empty empty-text="No hay cargos para mostrar"
            :items="positions.data" class="mt-3">

            <template v-if="validarPermisoComponente('empresa-editar-cargos')" v-slot:cell(actions)="data">
                <el-tooltip popper-class="py-1 px-2" effect="dark" placement="top-start" content="Editar">
                    <b-btn variant="primary" class="mx-1" size="sm" @click="openModalForEdition(data.item)">
                        <i class="fa fa-edit" />
                    </b-btn>
                </el-tooltip>

                <el-tooltip popper-class="py-1 px-2" effect="dark" placement="top-start" content="Eliminar">
                    <b-btn variant="danger" class="mx-1" size="sm" @click="deletePosition(data.item.id)">
                        <i class="fa fa-trash" />
                    </b-btn>
                </el-tooltip>
            </template>
        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="positions.data && !!positions.data.length" v-model="params.page"
            @size-change="fetchPositions()" @current-change="fetchPositions()" :current-page.sync="params.page"
            class="float-right" :page-size.sync="params.per_page" :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next" :total="positions.total" />

        <modal />
        <modal_upload />
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import modal from './modal.vue';
import modal_upload from './modal_upload.vue';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'index',
    components: {
        modal,
        modal_upload
    },
    data() {
        return {
            company_id: this.$route.params.id,
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('positions', [
            'positions',
            'params',
            'companies'
        ]),

        columns() {
            const columnsBase = [
                {
                    key: 'code',
                    label: 'Código',
                    thStyle: 'width: 100px'
                },
                //{
                //    key: 'wor_area.name',
                //    label: 'Área',
                //},
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'description',
                    label: 'Descripción',
                },
            ];

            if (this.validarPermisoComponente('empresa-editar-cargos')) {
                columnsBase.push({
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 110px',
                    tdClass: 'text-nowrap text-right'
                });
            }

            return columnsBase;
        }
    },
    async created() {
        this.resetParams();
        this.params.company_id = this.company_id;
        await this.fetchData();
        this.load(false);
    },
    methods: {
        ...mapActions('positions', [
            'fetchCompanies',
            'fetchPositions',
            'fetchAreas',
            'fetchEpps',
            'getPosition',
            'deletePosition',
            'fetchExams',
            'getLastPosition',
            'downloadTemplate'
        ]),
        ...mapMutations('positions', [
            'setModalShow',
            'resetParams',
            'setEditing',
            'resetPosition',
            'setShowToModalUpload'
        ]),
        ...mapMutations('dashboard', ['load']),
        ...mapActions('formBuilder', ['submissionsForModule']),
        async fetchData() {
            await this.fetchAreas(this.company_id);
            await this.submissionsForModule({ company_id: this.company_id, code_module: 'epps' });
            await this.fetchExams(this.company_id);
            await this.fetchPositions(true);
        },
        async openModalForCreation() {
            this.resetPosition();
            await this.getLastPosition();
            this.setEditing(false);
            this.setModalShow(true);
        },
        async openModalForEdition(position) {
            await this.getPosition(position.id);
            this.setEditing(true);
            this.setModalShow(true);
        },
        async resetParamsFilter() {
            this.resetParams();
            this.params.company_id = this.company_id;
            await this.fetchPositions(true);
        }
    }
};
</script>

<style scoped></style>
